import { Component, ViewEncapsulation, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { AccountService } from 'app/core';
import {
  User,
  Account,
  ProjectType,
  PropertyType,
  ProjectStage,
  InvestmentType,
  Team,
  Vehicle,
  MarketStatus,
  AccountIntegration,
} from 'app/core/models';
import { UserService } from 'app/layout/common/user/user.service';

@Component({
  selector: 'integrations-settings',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IntegrationsSettingsComponent implements OnDestroy {
  public dropdowns: any;
  private _unsubscribeAll: Subject<void>;

  public investmentTypes: InvestmentType[];
  public marketStatuses: MarketStatus[];
  public projectTypes: ProjectType[];
  public propertyTypes: PropertyType[];
  public projectStages: ProjectStage[];
  public teams: Team[];
  public vehicles: Vehicle[];
  public accountIntegrations: AccountIntegration[] = [];
  public account: Account;
  public currentUser: User;

  constructor(
    private _userService: UserService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _accountService: AccountService,
  ) {
    // Set the defaults
    this._unsubscribeAll = new Subject();

    this._accountService.currentAccount.subscribe((accountData) => {
      this.account = accountData;
    });

    this._userService.user$.pipe(takeUntil(this._unsubscribeAll)).subscribe((user: User) => {
      if (user) {
        this.currentUser = user;
      }
      this._changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  connectIntegration(accountIntegration): void {
    window.open(
      `${environment.baseUrl}/integrations/${accountIntegration.integration.slug}/setup?integration_id=${accountIntegration.integration_id}&user_id=${this.currentUser.id}`,
    );
  }
}
